import React from 'react';
import { Chip } from '@material-ui/core';

/**
 * Contrat du contrôle des données BGFA (domainModel .../integrations/prospect/problems).
 * Les noms de types et de champs du contrat sont isolés ici : si le backend les renomme,
 * on ajuste ce fichier seulement. Un type inconnu s'affiche avec son identifiant brut.
 */
export const PROBLEM_TYPE_LABELS = {
    agent_zone: 'Agents sans zone',
    model_manufacturer: 'Modèle / fabricant non reconnu',
    gender: 'Genre manquant',
    payment_plan: 'Plan de paiement inconnu',
    position: 'Installation sans position GPS',
    phase: 'Phase du compteur non renseignée',
    plan_minigrid: 'Type de facturation du compteur inconnu',
    kwh_missing: 'kWh manquants sur des paiements',
    telemetry_missing: 'Relevés compteurs manquants',
};

// Ordre d'affichage stable ; les types inconnus du frontal suivent, par ordre alphabétique.
export const PROBLEM_TYPE_ORDER = ['agent_zone', 'model_manufacturer', 'gender', 'payment_plan', 'position', 'phase', 'plan_minigrid', 'kwh_missing', 'telemetry_missing'];

// Couleur propre aux manques BGFA : distincte de Partiel (orange), Exclus (gris), Erreur (rouge),
// Importé (vert), Démo (bleu) et Simulation (gris bleuté) — un manque n'est pas une panne.
export const PROBLEMS_COLOR = '#6a1b9a';

export const PROBLEMS_BADGE_LABEL = 'Données BGFA incomplètes';

export function problemTypeLabel(type) {
    return PROBLEM_TYPE_LABELS[type] || type;
}

// Types présents dans une table de compteurs, dans l'ordre d'affichage.
export function orderedProblemTypes(counts) {
    const keys = Object.keys(counts || {});
    const known = PROBLEM_TYPE_ORDER.filter((t) => keys.indexOf(t) >= 0);
    const unknown = keys.filter((t) => PROBLEM_TYPE_ORDER.indexOf(t) < 0).sort();
    return known.concat(unknown);
}

// Total des compteurs d'une table {type: n} (champ `problems` d'une catégorie ou d'un journal).
export function totalProblems(problems) {
    if (!problems || typeof problems !== 'object') return 0;
    return Object.keys(problems).reduce((sum, k) => sum + (typeof problems[k] === 'number' ? problems[k] : 0), 0);
}

// Détail par type pour l'infobulle : « Agents sans zone : 2 ; Genre manquant : 5 ».
export function problemsTooltip(problems) {
    return orderedProblemTypes(problems)
        .filter((t) => problems[t] > 0)
        .map((t) => `${problemTypeLabel(t)} : ${problems[t]}`)
        .join(' ; ');
}

/**
 * Pastille « Données BGFA incomplètes (n) ». Ne rend rien quand il n'y a aucun manque.
 * Indépendante du statut Partiel / Exclus, et affichée aussi en simulation.
 * onClick facultatif : la pastille devient cliquable (renvoi vers le bloc de contrôle).
 */
export default function ProspectProblemsBadge({ problems, style, onClick }) {
    const total = totalProblems(problems);
    if (total <= 0) return null;
    const detail = problemsTooltip(problems);
    return (
        <Chip
            size="small"
            label={`${PROBLEMS_BADGE_LABEL} (${total})`}
            title={onClick ? `${detail} — cliquer pour voir et corriger` : detail}
            clickable={!!onClick}
            onClick={onClick || undefined}
            style={{ backgroundColor: PROBLEMS_COLOR, color: '#fff', cursor: onClick ? 'pointer' : undefined, ...style }}
        />
    );
}
